import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LlmChatQueueQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LlmChatQueueQuery = { __typename: 'PharosQuery', llmChatAdmin_List: { __typename: 'AdminLlmChatTypeListBase', objects: Array<{ __typename: 'AdminLlmChatType', id: string, created: string, lastMessage: any | null, minutesSinceLastMessage: number | null, processedAt: string | null, recordId: string | null, formId: string | null }> } | null };


export const LlmChatQueueDocument = gql`
    query llmChatQueue {
  llmChatAdmin_List(
    annotateLastMessage: true
    orderBy: [{field: lastMessage, direction: DESC}]
  ) {
    objects {
      id
      created
      lastMessage
      minutesSinceLastMessage
      processedAt
      recordId
      formId
    }
  }
}
    `;

/**
 * __useLlmChatQueueQuery__
 *
 * To run a query within a React component, call `useLlmChatQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useLlmChatQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLlmChatQueueQuery({
 *   variables: {
 *   },
 * });
 */
export function useLlmChatQueueQuery(baseOptions?: Apollo.QueryHookOptions<LlmChatQueueQuery, LlmChatQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LlmChatQueueQuery, LlmChatQueueQueryVariables>(LlmChatQueueDocument, options);
      }
export function useLlmChatQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LlmChatQueueQuery, LlmChatQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LlmChatQueueQuery, LlmChatQueueQueryVariables>(LlmChatQueueDocument, options);
        }
export function useLlmChatQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LlmChatQueueQuery, LlmChatQueueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LlmChatQueueQuery, LlmChatQueueQueryVariables>(LlmChatQueueDocument, options);
        }
export type LlmChatQueueQueryHookResult = ReturnType<typeof useLlmChatQueueQuery>;
export type LlmChatQueueLazyQueryHookResult = ReturnType<typeof useLlmChatQueueLazyQuery>;
export type LlmChatQueueSuspenseQueryHookResult = ReturnType<typeof useLlmChatQueueSuspenseQuery>;
export type LlmChatQueueQueryResult = Apollo.QueryResult<LlmChatQueueQuery, LlmChatQueueQueryVariables>;